module.exports = __webpack_public_path__ + "static/media/29EUNOG8.5764f7b7.jpg";